import type { UIMessage, ChatStatus } from "ai"
import { useEffect, useRef } from "react"
import { MessageBubble } from "./MessageBubble"

interface MessageListProps {
  messages: UIMessage[]
  isLoading: boolean
  status: ChatStatus
  error?: Error | undefined
}

export function MessageList({
  messages,
  isLoading,
  status,
  error,
}: MessageListProps) {
  const bottomRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" })
  }, [messages, isLoading, error])

  if (messages.length === 0 && !error) {
    return (
      <div className="flex-1 flex items-center justify-center opacity-40">
        <p className="text-center text-sm">
          Ask a question about your marketing data
        </p>
      </div>
    )
  }

  return (
    <div className="flex-1 overflow-y-auto px-4 py-3 space-y-2">
      {messages.map(message => (
        <MessageBubble key={message.id} message={message} />
      ))}
      {isLoading && !error && (
        <div className="chat chat-start">
          <div className="chat-bubble bg-system-blue-700 text-gray-100">
            <div className="flex items-center gap-2">
              <span className="loading loading-dots loading-sm" />
              {status === "submitted" && (
                <span className="text-xs opacity-60">Thinking...</span>
              )}
            </div>
          </div>
        </div>
      )}
      {error && (
        <div className="chat chat-start">
          <div className="chat-bubble bg-error/20 text-error border border-error/30">
            <p className="text-sm font-medium">Something went wrong</p>
            <p className="text-xs opacity-80 mt-1">{error.message}</p>
          </div>
        </div>
      )}
      <div ref={bottomRef} />
    </div>
  )
}
